import React, { useState } from 'react';
import styles from "./notificationsettings.module.css";
import HeadingComponent from '../../../components/HeadingComponent/HeadingComponent';
import { TextComponent } from '../../../components';

const NotificationSettings = () => {
  const [notifications, setNotifications] = useState({
    // newJobs: false,
    // bidUpdate: false,
    // messageNotifications: false
    newOrderAssigned: false,
    orderCompleted: false,
    orderFlagged: false,
    flaggedIssueResult: false
  });

  const toggleNotification = (type) => {
    setNotifications((prev) => ({
      ...prev,
      [type]: !prev[type] // Toggle only the clicked switch
    }));
  };

  return (
    <div className={styles.AccountContent}>
      
      <TextComponent text={"Notification Preference"} className={styles.labelText} />

      {/* New Jobs Toggle */}
      <div className={styles.enableToggle}>
        <label className={styles.label}>New Order Assigned</label>
        <label className={styles.switch}>
          <input 
            type="checkbox" 
            checked={notifications.newJobs} 
            onChange={() => toggleNotification("newOrderAssigned")} 
          />
          <span className={styles.slider}></span>
        </label>
      </div>

      {/* Bid Update Toggle */}
      <div className={styles.enableToggle}>
        <label className={styles.label}>Order Completed</label>
        <label className={styles.switch}>
          <input 
            type="checkbox" 
            checked={notifications.bidUpdate} 
            onChange={() => toggleNotification("orderCompleted")} 
          />
          <span className={styles.slider}></span>
        </label>
      </div>

      {/* Message Notifications Toggle */}
      <div className={styles.enableToggle}>
        <label className={styles.label}>Order Flagged</label>
        <label className={styles.switch}>
          <input 
            type="checkbox" 
            checked={notifications.messageNotifications} 
            onChange={() => toggleNotification("orderFlagged")} 
          />
          <span className={styles.slider}></span>
        </label>
      </div>

      {/* Message Notifications Toggle */}
      <div className={styles.enableToggle}>
        <label className={styles.label}>Flagged Issue Result</label>
        <label className={styles.switch}>
          <input 
            type="checkbox" 
            checked={notifications.messageNotifications} 
            onChange={() => toggleNotification("flaggedIssueResult")} 
          />
          <span className={styles.slider}></span>
        </label>
      </div>
    </div>
  );
}

export default NotificationSettings;
